var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC2CLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3958,
    cy: 8.45635,
    r: 2.40753,
    fill: "#111219"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.431,
    cy: 18.9925,
    r: 2.40753,
    fill: "#111219"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9924 19.6799V16.0821C14.9924 14.0951 13.3816 12.4844 11.3946 12.4844V12.4844C9.40764 12.4844 7.79688 14.0951 7.79688 16.0821V19.6799",
    stroke: "#111219",
    strokeWidth: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0314 30.217V26.6192C28.0314 24.6323 26.4207 23.0215 24.4337 23.0215V23.0215C22.4467 23.0215 20.8359 24.6323 20.8359 26.6192V30.217",
    stroke: "#111219",
    strokeWidth: 2.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0336 13.5356V8.2832H22.7812",
    stroke: "#863DFF",
    strokeWidth: 2.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5273 8.28217L24.2078 6.04883V10.5155L20.5273 8.28217Z",
    fill: "#863DFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79449 22.73V27.9824H13.0469",
    stroke: "#863DFF",
    strokeWidth: 2.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3047 27.9835L11.6243 30.2168V25.7501L15.3047 27.9835Z",
    fill: "#863DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2CLight);
export default __webpack_public_path__ + "static/media/C2C_light.a45517f4290d79d4cec8e732d1986d1a.svg";
export { ForwardRef as ReactComponent };